<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-07 08:40:45
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-02 17:23:49
 * @FilePath: \Home\Transfor-website\src\views\pc\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div>
      <div class="Mains">
        <div class="Main-W">
          <div class="Main-headline">
            <p>Transformers enables multiple block producers to <span style="color:#cf61dc;">parallelize block production</span> a decentralized and distributed network</p>
            <!-- <p>
              {{ $t("Main.Sustainable") }}
            </p>
            <p>
              {{ $t("Main.expansionof") }}
            </p>
            <p>
              {{ $t("Main.low") }}
            </p>
            <p>
              {{ $t("Main.decentralized") }}
            </p>
            <p>
              {{ $t("Main.networks") }}
            </p> -->
          </div>
          <p class="Main-TheTransformers">
            The block generation time can be shortened to 0.1 seconds, with a transaction processing capacity of over 100,000+.
          </p>
          <!-- <img src="@/assets/pc/Home/矩形 27@2x(1).png" class="Img1" />
          <img src="@/assets/pc/Home/矩形 27@2x(1).png" class="Img2" /> -->
          <img
            src="https://fastcdn.uscloudmedia.com/transformers/osite/animation_640_l3i9ykrn.gif"
            class="ImgGif"
          />
        </div>
      </div>
    </div>
    <HomeConter />
    <HomeBottom />
  </div>
</template>

<script>
import { goPAGE } from "@/utils/utils";
// import Search from "@/components/pc/Search";
import Vue from "vue";
import HomeConter from "../pc/Home/homeConter";
import HomeBottom from "../pc/Home/homeBottom";
// import { Button, Toast, Popover } from "vant";
// Vue.use(Search);
// Vue.use(Toast).use(Popover).use(Button);
// Vue.use(Popover);
const echarts = require("echarts");
export default {
  data() {
    return {
      IMgUrl: "",
      W: document.body.clientWidth + "px",
    };
  },
  components: {
    // Search: Search,
    // Search,
    HomeConter,
    HomeBottom,
  },
  computed: {
    goPage() {
      return goPAGE();
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="less">
.Mains {
  width: 100%;
  // height: 900px;
  background: #f4f4f4;
  // background: url("../../assets/pc/Home/Group 2@2x.png");
  // background-repeat: no-repeat;
  // background-size: 100%;
  // overflow: hidden;

  .Main-W {
    width: 1320px;
    // height: 900px;
    margin: 0 auto;
    padding-bottom: 144px;
    position: relative;
    padding-top: 64px;
    background: #f4f4f4;
    .Main-headline {
      width: 595px;
      height: 470px;
      margin-top: 96px;
      p {
        width: 595px;
        height: 34px;
        font-size: 55px;
        font-family:"Microsoft YaHei";
      //  font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #141414;
        line-height: 68px;
        word-spacing: -2px;
        margin-bottom: 10px;
      }
      p:nth-child(3) {
        color: #cf61dc;
      }
    }
    p {
      width: 476px;
      // height: 84px;
      font-size: 18px;
      // font-family: PingFangSC-Regular, sans-serif;
     font-family:'Microsoft YaHei';
     // font-family:"Microsoft YaHei";
     // font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
      font-weight: 400;
      color: #141414;
      line-height: 28px;
    }
    .Main-TheTransformers {
      margin-top: 32px;
      img{
        margin-top: 14px;
      }
    }
    .ImgGif {
      width: 640px;
      height: 640px;
      position: absolute;
      top: 121px;
      right: 0;
    }
    img {
    }
    .Img1 {
      width: 245px;
      height: 280px;
      position: absolute;
      top: 15%;
      left: -31%;
      // position: relative;
      // animation: animationname 3s infinite;
      // -webkit-animation: animationname 3s infinite;
      // background: #fff;
    }
    // @keyframes animationname {
    //   0% {
    //     transform: perspective(400px) rotateY(0);
    //   }
    //   100% {
    //     transform: perspective(400px) rotateY(360deg);
    //   }
    // }
    .Img2 {
      width: 196px;
      height: 281px;
      position: absolute;
      bottom: -6%;
      right: -25%;
      // background: #FFF;
    }
  }
}
</style>
